module.exports = __webpack_public_path__ + "img/sol_isol_pain3.47b1bdf0.png";